export {default} from './EntityTable.container';
